import { intersection } from 'lodash';

export default function GetAllowedRoutesFromRole(routes, roles) {

    function isArrayWithLength(arr) {
        return (Array.isArray(arr) && arr.length);
    }

    return routes.filter(({ permission }) => {

        if (!permission || !isArrayWithLength(permission)) {
            return true;
        } else {
            return intersection(permission, roles).length;
        }
    });
}